module.exports = __webpack_public_path__ + "static/img/xin3.2dc3af0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/xin3.jpg
// module id = u+LR
// module chunks = 0